import * as i0 from '@angular/core';
import { input, computed, ChangeDetectionStrategy, Component } from '@angular/core';

var EffyButtonSize;
(function (EffyButtonSize) {
    EffyButtonSize["SMALL"] = "small";
    EffyButtonSize["MEDIUM"] = "medium";
    EffyButtonSize["LARGE"] = "large";
})(EffyButtonSize || (EffyButtonSize = {}));
var EffyButtonStyle;
(function (EffyButtonStyle) {
    EffyButtonStyle["PRIMARY"] = "primary";
    EffyButtonStyle["SECONDARY"] = "secondary";
    EffyButtonStyle["TERTIARY"] = "tertiary";
    EffyButtonStyle["QUATERNARY"] = "quaternary";
    EffyButtonStyle["TAG"] = "tag";
    EffyButtonStyle["GHOST"] = "ghost";
})(EffyButtonStyle || (EffyButtonStyle = {}));

class EffyButtonComponent {
    constructor() {
        this.size = input(EffyButtonSize.LARGE);
        this.color = input(EffyButtonStyle.PRIMARY);
        this.loading = input(false);
        this.hostClasses = computed(() => `effy-button effy-button-${this.size()} effy-button-${this.color()}${this.loading() ? ' effy-button--loading' : ''}`);
        this.spinnerDiameter = computed(() => {
            const size = this.size();
            if (size === EffyButtonSize.SMALL) {
                return 16;
            }
            return 24;
        });
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "19.2.13", ngImport: i0, type: EffyButtonComponent, deps: [], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "17.0.0", version: "19.2.13", type: EffyButtonComponent, isStandalone: true, selector: "[effy-button]", inputs: { size: { classPropertyName: "size", publicName: "size", isSignal: true, isRequired: false, transformFunction: null }, color: { classPropertyName: "color", publicName: "color", isSignal: true, isRequired: false, transformFunction: null }, loading: { classPropertyName: "loading", publicName: "loading", isSignal: true, isRequired: false, transformFunction: null } }, host: { properties: { "class": "hostClasses()" } }, ngImport: i0, template: "<ng-content></ng-content>\n@if (loading()) {\n  @defer {\n    <mat-progress-spinner [diameter]=\"spinnerDiameter()\" mode=\"indeterminate\" />\n  }\n}\n", styles: [""], changeDetection: i0.ChangeDetectionStrategy.OnPush, deferBlockDependencies: [() => [import('@angular/material/progress-spinner').then(m => m.MatProgressSpinner)]] }); }
}
i0.ɵɵngDeclareClassMetadataAsync({ minVersion: "18.0.0", version: "19.2.13", ngImport: i0, type: EffyButtonComponent, resolveDeferredDeps: () => [import('@angular/material/progress-spinner').then(m => m.MatProgressSpinner)], resolveMetadata: MatProgressSpinner => ({ decorators: [{
                type: Component,
                args: [{ selector: '[effy-button]', imports: [MatProgressSpinner], changeDetection: ChangeDetectionStrategy.OnPush, host: {
                            '[class]': 'hostClasses()',
                        }, template: "<ng-content></ng-content>\n@if (loading()) {\n  @defer {\n    <mat-progress-spinner [diameter]=\"spinnerDiameter()\" mode=\"indeterminate\" />\n  }\n}\n" }]
            }], ctorParameters: null, propDecorators: null }) });

/**
 * Generated bundle index. Do not edit.
 */

export { EffyButtonComponent, EffyButtonSize, EffyButtonStyle };
